import { useFormik } from "formik";
import * as Yup from "yup";
import { useGetFilterBasicDataQuery } from "../../../../store/queries/Admin";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  updateConfig,
  resetConfig,
} from "../../../../store/slices/Admin/AiOrders/aiOrdersSlice";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useGetUserDetailsDataQuery } from "../../../../store/queries/Global";

const useFilter = () => {
  const dispatch = useDispatch();
  const [isStoreAvailable, setIsStoreAvailable] = useState(false);
  const { data: orderBasicData = {} } = useGetFilterBasicDataQuery();
  const { data: userData = {} } = useGetUserDetailsDataQuery();

  useEffect(() => {
    if (userData?.data?.hasOwnProperty(`customer_key`)) {
      formik?.setFieldValue("store_name", userData?.data?.customer_key);
      setIsStoreAvailable(true);
    }
    //eslint-disable-next-line
  }, []);
  const orderState = useSelector((state) => state.orders);
  const validation = Yup.object({
    store_name: Yup.array().nullable(),
    payment_mode: Yup.array().nullable(),
    status: Yup.array().nullable(),
    offer: Yup.array().nullable(),
  });
  const formik = useFormik({
    initialValues: {
      store_name: orderState?.store_name ?? [],
      payment_mode: orderState?.payment_mode ?? [],
      status: orderState?.status ?? [],
      offer: orderState?.offer ?? [],
    },
    validationSchema: validation,
    onSubmit: (values) => {
      const { store_name, payment_mode, status, offer } = values;
      if (store_name === "" && payment_mode === "" && status === "" && offer === "") {
        toast.error(`All fields are empty`);
      } else {
        dispatch(
          updateConfig((state) => [
            (state.store_name = values?.store_name),
            (state.payment_mode = values?.payment_mode),
            (state.status = values?.status),
            (state.offer = values?.offer),
          ])
        );
        handleClose();
      }
    },
  });
  const handleClose = () => {
    dispatch(
      updateConfig((state) => {
        state.filterShow = false;
      })
    );
  };
  const handleReset = () => {
    dispatch(resetConfig());
    handleClose();
  };

  let storeList = orderBasicData?.data?.store_name?.map((item) => {
    return {
      name: item?.name,
      id: item?.customer_key,
    };
  });
 
  return {
    formik,
    storeList,
    orderBasicData,
    isStoreAvailable,
    handleReset,
  };
};

export default useFilter;
